/**
 * Branding in one place. The product name is a working name (PRD Q2 open); when it is
 * decided, change this file (and public/icons, manifest.webmanifest, index.html meta —
 * see docs/DESIGN.md "Rebranding"). Nothing else in the app hard-codes the name.
 * The organisation's own name and logo come from the session (each client is a tenant).
 */
export const BRAND = {
  /** Product name shown in the sidebar, sign-in and title bar. */
  product: 'QXM',
  /** Short form for tight spots (installed app name, collapsed sidebar). */
  short: 'QXM',
  /** One line under the wordmark on the sign-in screen. */
  tagline: 'Controlled documents, found in seconds',
  /**
   * Sign-in landing headline (boss TG 1344, 25 Oct 2026: education customers). Wording rule: "supports … requirements",
   * never "certified" / "compliant". Empty title = the plain sign-in card without the hero.
   */
  landing: {
    /** Landing brand (boss TG 1355/1356): Veltrion is the app name on the landing page; no "QXM" there until production. */
    appName: 'Veltrion',
    logoLight: '/brand/veltrion_logo_light.webp',
    logoDark: '/brand/veltrion_logo_dark.webp',
    /** Partner company (boss TG 1355). New AGF Digital logo from the boss (TG 1690, 4 Nov 2026): ~/templates/brand/agf/2026-11-04. */
    partnerName: 'AGF Digital',
    partnerLogo: '/brand/agf_digital_logo.webp',
    /** Card greeting above "Sign in" (AGF's landing mock-up, boss TG 1689). */
    welcome: 'Welcome to AGF Digital™',
    poweredBy: 'IT Core Solutions Inc.',
    poweredByLogo: '/brand/itcore_logo.webp',
    eyebrow: 'ISO 21001:2025',
    title: 'Educational Organizations Management System',
    subtitle: 'Document Control',
    body: 'Simplify how your organization creates, reviews, approves, revises, distributes, and maintains documented information, with full traceability and audit readiness.',
    features: ['Documents & Records', 'Approval Workflows', 'Version Control', 'Controls & Audit Trail', 'Audit Readiness'],
    standards: [
      { code: 'ISO 21001:2025', name: 'Educational Organizations' },
      { code: 'ISO 9001:2026', name: 'Quality Management' },
    ],
    heroUrl: '/hero-edu.webp',
  },
  /** Optional product logo (served from /public). Empty = the catalogue-drawer wordmark. */
  logoUrl: '' as string,
  /** Who runs the service, for the footer and Help. */
  operator: 'ITCORE Solutions Inc.',
  supportEmail: 'support@itcore-apps.com',
  /** Browser tab title suffix: "Search – QXM". */
  titleSuffix: 'QXM',
} as const;

export const pageTitle = (title?: string): string => (title ? `${title} – ${BRAND.titleSuffix}` : BRAND.titleSuffix);
